import type {Theme} from '@material-ui/core/styles';
import {createStyles} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    root: {
        width: '65.278vw', //  Calc ViewPort Units: 940/1440*100
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(10, 30, 10, 30),
    },
}));
